/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:cbe89423-f59f-44fc-8398-6147844dfeff",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_qqadJxTlM",
    "aws_user_pools_web_client_id": "381uvfenpnr7icbqdm7hqg78su",
    "oauth": {}
};


export default awsmobile;
